import { api } from './client';

const base = (slug: string) => `/trips/${encodeURIComponent(slug)}/api`;

/**
 * GET /trips/<slug>/api/malle-tips
 *
 * Liefert Custom-Tipps (admin-konfiguriert) + KI-Tipps (Claude, gecacht 30d
 * im KV) gemerged in einer einzigen `tips`-Liste. Custom-Tipps stehen vorne.
 *
 * `force=1` umgeht den 30d-KV-Cache und regeneriert die KI-Tipps. Reserviert
 * für Admin-Aktionen (rate-limited durch Anthropic-Backend).
 */
export interface MalleTipsResponse {
  tips: string[];
  customCount: number;
  aiCount: number;
  model: string;
  generatedAt: number;
  cached: boolean;
  error?: string;
}

export function fetchMalleTips(
  slug: string,
  options: { force?: boolean; signal?: AbortSignal } = {},
): Promise<MalleTipsResponse> {
  const qs = options.force ? '?force=1' : '';
  return api.get<MalleTipsResponse>(`${base(slug)}/malle-tips${qs}`, { signal: options.signal });
}
